import { SearchBaseModel } from '../commonModels';

export class CatalogueSearchModel extends SearchBaseModel {

  constructor() {
    super();
    this.Dimension = null;
    this.TyreSegmentId = null;
    this.Code = null;
    this.BrandId = null;
    this.SeasonId = null;
    this.IsCurrent = null;
    this.Tread = null;
    this.Article = null;
    this.IsRFT = null;
    this.TyrecartypeId = null;
    this.IsReinforcement = null;
    this.SpeedIndex = null;
    this.IsUnspecified = null;
    }

  public Dimension: string;
  public TyreSegmentId: number;
  public Code: string;
  public BrandId: number;
  public SeasonId: number;
  public IsCurrent: boolean;
  public Tread: string;
  public Article: string;
  public IsRFT: boolean;
  public TyrecartypeId: number;
  public IsReinforcement: boolean;
  public SpeedIndex: string;
  public IsUnspecified: boolean;
}
